import { render, staticRenderFns } from "./staandart-category-count.vue?vue&type=template&id=4a09ba7b&"
import script from "./staandart-category-count.vue?vue&type=script&lang=ts&"
export * from "./staandart-category-count.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports